const STORE_GROUP_PREFIX = "store"

export const createStoreObjectiveItemGroupId = (storeCode: string) =>
  `${STORE_GROUP_PREFIX}-${storeCode}`.toLowerCase().trim()
